export default __webpack_public_path__ + "static/media/Icon-Operation-Fill-Bookmark.a6d21d77.svg";